module.exports = __webpack_public_path__ + "static/assets/a2e869a51a285f91ad55f07efedbbcc9.jpg";